import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

declare const $: any;

interface GroupEntry {
    code: string;
    group_id: number;
    services: any[];
}

@Component({
    selector: 'app-service-expense-group-modal',
    templateUrl: './service-expense-group-modal.component.html',
    styleUrls: ['./service-expense-group-modal.component.scss']
})
export class ServiceExpenseGroupModalComponent implements OnInit, OnChanges {
    @Input() services: any[] = [];
    @Output() servicesSelected = new EventEmitter<number[]>();
    @Output() modalClosed = new EventEmitter<void>();

    groupChecked: { [groupId: number]: boolean } = {};
    serviceChecked: { [serviceId: number]: boolean } = {};
    expandedGroups: { [code: string]: boolean } = {};

    groupedServices: GroupEntry[] = [];
    ungroupedServices: any[] = [];

    get selectedCount(): number {
        const groups = Object.values(this.groupChecked).filter(Boolean).length;
        const svcs = Object.values(this.serviceChecked).filter(Boolean).length;
        return groups + svcs;
    }

    ngOnInit(): void {
        this.buildLists();
        setTimeout(() => $('#serviceExpenseGroupModal').modal({ backdrop: 'static', keyboard: false }), 0);
        setTimeout(() => $('#serviceExpenseGroupModal').modal('show'), 0);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['services'] && !changes['services'].firstChange) {
            this.buildLists();
        }
    }

    private buildLists(): void {
        const map = new Map<number, GroupEntry>();
        const ungrouped: any[] = [];
        const seenIds = new Set<number>();

        for (const s of (this.services || [])) {
            const sid = Number(s.service_id);
            if (seenIds.has(sid)) continue;
            seenIds.add(sid);

            const groupId = s.group_id != null ? Number(s.group_id) : null;
            const code = (s.group_code || '').trim();

            if (s.has_group && groupId && code) {
                if (!map.has(groupId)) {
                    map.set(groupId, { code, group_id: groupId, services: [] });
                    if (this.expandedGroups[code] === undefined) {
                        this.expandedGroups[code] = true;
                    }
                }
                map.get(groupId)!.services.push(s);
            } else {
                ungrouped.push(s);
            }
        }

        this.groupedServices = Array.from(map.values());
        this.ungroupedServices = ungrouped;
    }

    toggleGroupExpand(event: Event, code: string): void {
        this.expandedGroups = { ...this.expandedGroups, [code]: !this.expandedGroups[code] };
    }

    stopAndToggleService(event: Event, serviceId: number): void {
        event.stopPropagation();
        this.serviceChecked = { ...this.serviceChecked, [serviceId]: !this.serviceChecked[serviceId] };
    }

    trackByCode(_: number, g: GroupEntry): string { return g.code; }
    trackById(_: number, s: any): number { return s.service_id; }

    formatDateTime(date: string, time: string): string {
        if (!date) return '';
        return time ? `${date} ${time}` : date;
    }

    confirm(): void {
        const ids: number[] = [];

        for (const group of this.groupedServices) {
            if (this.groupChecked[group.group_id] && group.services.length > 0) {
                ids.push(group.services[0].service_id);
            }
        }

        for (const s of this.ungroupedServices) {
            if (this.serviceChecked[s.service_id]) {
                ids.push(s.service_id);
            }
        }

        $('#serviceExpenseGroupModal').modal('hide');
        this.servicesSelected.emit(ids);
    }

    skip(): void {
        $('#serviceExpenseGroupModal').modal('hide');
        this.modalClosed.emit();
    }
}
